import * as React from "react";
import styled from "styled-components";
import ColorPicker from "../ColorPicker";

const Base = styled.div``;

const Preview = styled.div`
  height: 50px;
`;

const Bottom = styled.div`
  display: flex;

  & > *:first-child {
    margin-right: 24px;
  }

  & > * {
    flex: 1;
  }
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  value: [string, string];
  onChange: (value: [string, string]) => void;
  labelLeft: string;
  labelRight: string;
};

export default function GradientPicker({
  value = ["#ffffff", "#ffffff"],
  onChange,
  labelLeft,
  labelRight,
  style,
  className
}: Props) {
  return (
    <Base style={style} className={className}>
      <Preview
        style={{
          marginBottom: 16,
          background: `linear-gradient(to right, ${value[0]} 0%, ${
            value[1]
          } 100%)`
        }}
      />
      <Bottom>
        <ColorPicker
          label={labelLeft}
          value={value[0]}
          onChange={color => onChange([color, value[1]])}
        />
        <ColorPicker
          label={labelRight}
          value={value[1]}
          onChange={color => onChange([value[0], color])}
        />
      </Bottom>
    </Base>
  );
}
